var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { baseFetch } from "../../utility/api";
import { handleResponse } from "../../utility/api/handleResponse";
/**
 * Async function that will perform a fetch depending on arguments and return customization options
 *
 * @param args Uses GetArgs type, which consists of access token, environment, and guid
 * @returns Returns an array of Customization Options
 *
 * @example
 *
 * ```ts
 * customization.api.get({
 *        access_token: "at-1234",
 *        environment: "ios-dev",  // environment: "<Platform Name>-<EnvironmentName>"
 *        guid: "guid-1234",
 *       })
 * ```
 */
export function get(args) {
    return __awaiter(this, void 0, void 0, function* () {
        const { access_token, guid, environment } = args;
        const url = `/acs/v1/customers/${guid}/customizations`;
        const fetcher = baseFetch({ environment });
        const response = yield fetcher(url, {
            headers: { Authorization: `Bearer ${access_token}` },
        });
        const json = yield handleResponse(response);
        return json;
    });
}
//# sourceMappingURL=index.js.map